import { HeaderNavItem } from "@shetharp/gatsby-theme-polaroid";

export const headerNavItems: HeaderNavItem[] = [
  // {
  //     label: "Blog",
  //     slug: "/blog",
  //     isVisibleMobile: true,
  //     isVisibleTablet: true,
  // },
  {
    label: "GitHub",
    href: "https://github.com/deepsheth",
  },
  {
    label: "About",
    slug: "/about",
    isVisibleTablet: true,
  },
  {
    label: "Contact",
    slug: "/contact",
    isVisibleTablet: true,
  },
];
